import React from 'react';
import { useSelector } from 'react-redux';
import { selectIsHospital } from '@components/Auth';
import { SearchFormFrontlineUser } from './search-form-frontline-user';
import { SearchFormHospitalUser } from './search-form-hospital-user';

const InsurancePolicyUserSearchForm = () => {
  const isHospital = useSelector(selectIsHospital);
  return isHospital ? <SearchFormHospitalUser /> : <SearchFormFrontlineUser />;
};

export { InsurancePolicyUserSearchForm };
